import type React from 'react';

/**
 * Keeps a click on a suggestion from interrupting the editor it belongs to.
 *
 * A suggestion sits inside the element but outside its editor, so the element container reads a
 * mousedown on it as a click away from the editor and stops editing (see ElementContainer.onMouseDown).
 * The editor is then no longer editable, so it blurs, and a store sync is free to replace its content -
 * undoing what the suggestion just changed and dropping the caret at the end of the document.
 *
 * Not letting the mousedown reach the container also leaves the element unselected, as the legacy
 * suggestions did.
 */
export const keepEditorEditing = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
};
